import { render, staticRenderFns } from "./addDelivery.vue?vue&type=template&id=f7e49e20&"
import script from "./addDelivery.vue?vue&type=script&lang=js&"
export * from "./addDelivery.vue?vue&type=script&lang=js&"
import style0 from "./addDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports